import { useMutation } from '@tanstack/react-query'

import type { SaveChatThreadEvent } from '../@types'
import { createChatThreadEvent } from '../api'

const useSaveChatThreadEvent = () => {
  return useMutation({
    mutationKey: ['saveChatThreadEvent'],
    mutationFn: (text: SaveChatThreadEvent['attributes']['text']) =>
      createChatThreadEvent({
        type: 'chat_thread_event',
        attributes: {
          event_type: 'TEXT',
          text,
        },
      }),
  })
}

export default useSaveChatThreadEvent
